import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import fetchWrapper from '../utils/httpClient';
import {
  API_SUPPORT_PORTAL_LOGIN,
  API_INVALIDATE_TOKEN,
  API_SUPPORT_PORTAL_VERIFY_OTP
} from '../utils/apis';

import { decodedJWTPayload } from '../utils/commonUtil';

// Login thunk
export const login = createAsyncThunk('auth/login', async (credentials) => {
  try {
    const response = await fetchWrapper.post(API_SUPPORT_PORTAL_LOGIN, credentials);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
});

export const verifyOtp = createAsyncThunk(
  'auth/verifyOtp',
  async (otpData, { rejectWithValue }) => {
    try {
      const response = await fetchWrapper.post(API_SUPPORT_PORTAL_VERIFY_OTP, otpData);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'OTP verification failed');
    }
  }
);

// Logout thunk
export const logout = createAsyncThunk('auth/logout', async () => {
  const token = localStorage.getItem('access_token');
  try {
    await fetchWrapper.post(API_INVALIDATE_TOKEN, { token });
    localStorage.removeItem('access_token');
    return;
  } catch (error) {
    throw new Error(error.message);
  }
});

const supportportalLoginSlice = createSlice({
  name: 'supportportalLogin',
  initialState: {
    user: null,
    userInfo: null,
    loading: false,
    error: null,
    status: 'idle',
    otpStatus: 'idle',
    otpError: null
  },
  reducers: {
    setUserInfo: (state, action) => {
      state.userInfo = action.payload;
    },
    clearUserInfo: (state) => {
      state.userInfo = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(verifyOtp.fulfilled, (state, action) => {
        state.loading = false;
        state.user = {
          ...state.user,
          ...action.payload.resdata
        };
        state.otpStatus = 'succeeded';

        const token = action.payload.resdata.access_token;
        if (token) {
          try {
            const userInfo = decodedJWTPayload(token);
            state.userInfo = userInfo;
          } catch (error) {
            console.error('Failed to decode token:', error);
          }
        }
      })
      .addCase(logout.fulfilled, (state) => {
        state.loading = false;
        state.user = null;
        state.userInfo = null;
        state.status = 'succeeded';
        state.otpStatus = 'idle';
      });
  }
});

export const { setUserInfo, clearUserInfo } = supportportalLoginSlice.actions;

export default supportportalLoginSlice.reducer;